import { generateSearchHistoryKey } from '@/features/search/_utils/local-storage';
import type { fundSheetTypeEnum } from '@/utils/enum';
import type { z } from 'zod';

export const FEATURE_KEY = {
  RS: 'rs-projects-table',
  SS: 'ss-projects-table',
  KS: 'ks-projects-table',
  KS_LOCAL_GOVERNMENT: 'ks-local-government-projects-table',
  KS_INVESTMENT: 'ks-investment-projects-table',
};

export const FundSheetTableColumnSettingsKeyModifier = {
  standard: 'KS',
  'local-government': 'KS_LOCAL_GOVERNMENT',
  investment: 'KS_INVESTMENT',
} as const satisfies Record<z.infer<typeof fundSheetTypeEnum>, string>;

export const SEARCH_HISTORY_KEY = generateSearchHistoryKey('rs-project');

export const DISPLAY_SETTING_KEY = {
  TABLE_NEST_SETTING: 'table-nest-setting',
  TABLE_COLUMNS_SETTING: 'table-columns-setting',
  PROJECT_LEDGER_VIEW_SETTING: 'project-ledger-view-setting',
};

export const FEATURE_TYPE_KEY = {
  GROUP: 'group',
  LIST: 'list',
};

export const getStorageSettingKey = (
  state: string,
  feature: string,
  param: string,
) => {
  return `${state}.${feature}.${param}`;
};
